'use client';

import { useState, useEffect } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import LearnDropdown from './Dropdown';
// Import workshops data
import workshops from '@/data/workshops.json';

export default function Navbar({ programs }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`fixed top-0 w-full z-50 transition-all duration-300 overflow-visible ${isScrolled ? 'bg-white shadow-sm' : 'bg-white'}`}>
      <div className="w-[90%] md:w-[80%] mx-auto">
        <nav className="py-6 flex items-center justify-between">
          
          {/* Left: Logo + Desktop Nav */}
          <div className="flex items-center space-x-6 ">
            <Link href="/" >
              <Image
                src="https://d31bwppm8yl9g2.cloudfront.net/learner/website/gsmainlogo.svg"
                alt="Growth School"
                width={100}
                height={40}
                priority
                className='mr-6'
              />
            </Link>
            <div className="hidden md:flex items-center gap-4">
              {/* Pass both programs and workshops to the dropdown */}
              <LearnDropdown programs={programs} workshops={workshops} />
              <Link href="https://home.growthschool.io/b2b" className="px-4 py-2 font-medium text-base text-[#002726] hover:text-[#004D4B] transition-colors">
                Upskill your Team
              </Link>
              <Link href="/about-us" className="px-4 py-2 text-[#002726] text-base font-medium hover:text-[#004D4B] transition-colors">
                About
              </Link>
            </div>
          </div>

          {/* Right: Mobile Learn + Hamburger  |  Desktop Actions */}
          <div className="flex items-center space-x-3">
            {/* on mobile show LearnDropdown here */}
            <div className="md:hidden">
              {/* Also pass workshops data to mobile dropdown */}
              <LearnDropdown programs={programs} workshops={workshops} />
            </div>

            <button
              onClick={() => setIsMenuOpen(o => !o)}
              className="md:hidden p-1.5 border border-[#002726] rounded-md text-[#002726]"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M4 6H20M4 12H20M4 18H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>

            <div className="hidden md:flex items-center space-x-3">
              <Link href="https://serv-learner-prod.growthschool.io/auth/login" className="px-5 py-2 border font-medium text-base border-[#002726] rounded-md text-[#002726] hover:text-white hover:bg-[#012726] transition-colors">
                Login
              </Link>
              <Link href="https://forms.growthschool.io/custom/apply-as-a-mentor-at-growthschool/8125ff18-d4a1-42d1-a6f6-0f3bcd3c840a" className="px-5 py-2 border font-medium text-base border-[#002726] rounded-md text-[#002726] hover:text-white hover:bg-[#012726] transition-colors">
                Apply as Mentor
              </Link>
            </div>
          </div>
        </nav>

        <div className="h-px bg-gray-200"></div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          <Link href="https://home.growthschool.io/b2b" className="block px-6 py-3 hover:bg-gray-50 " onClick={() => setIsMenuOpen(false)}>
            Upskill your Team
          </Link>
          <Link href="/about-us" className="block px-6 py-3 hover:bg-gray-50" onClick={() => setIsMenuOpen(false)}>
            About
          </Link>
          <div className="px-6 py-3 space-y-3">
            <Link href="https://serv-learner-prod.growthschool.io/auth/login" className="block w-full py-3 text-center border border-[#002726] rounded-md" onClick={() => setIsMenuOpen(false)}>
              Login
            </Link>
            <Link href="https://forms.growthschool.io/custom/apply-as-a-mentor-at-growthschool/8125ff18-d4a1-42d1-a6f6-0f3bcd3c840a" className="block w-full py-3 text-center border border-[#002726] rounded-md" onClick={() => setIsMenuOpen(false)}>
              Apply as Mentor
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}